import { List } from 'components/list'
import { MovieListItem } from 'components/movieListItem'
import VideoPlayer from 'components/video-player'

export default function Movie() {
    const itemList = [
        {
            image: 'https://s199.imacdn.com/vg/2022/10/19/2c4230571a2039b9_bf71d200b518a2f4_6027216661555007118684.jpg',
            title: 'Tập đặc biệt - 1',
            views: 266889
        },
        {
            image: 'https://s199.imacdn.com/vg/2022/10/10/df33e31ce6c35ea2_9859e7bcecd8f0ee_7675316653771888118684.jpg',
            title: 'Tập 1 - Giấc mơ',
            views: 103338
        },
        {
            image: 'https://s199.imacdn.com/vg/2022/10/16/2e9e277f65a6934e_f4c2f2b50ae0bee0_2436816659075419118684.jpg',
            title: 'Tập 2 - Quái vật',
            views: 89863
        },
        {
            image: 'https://s199.imacdn.com/vg/2022/10/23/4ebdbf14cf79e26c_06b18586707a6881_2144216665127633118684.jpg',
            title: 'Tập 3 - Số 0 của bóng đá',
            views: 77853
        },
        {
            image: 'https://s199.imacdn.com/vg/2022/10/30/22573558ddc8329c_f19563156624cbcd_3112616671154127118684.jpg',
            title: 'Tập 4 - Linh cảm và trực giác',
            views: 74173
        },
        {
            image: 'https://s199.imacdn.com/vg/2022/11/06/8c197398827474ae_d7467b8b54f347fc_2925816677058429118684.jpg',
            title: 'Tập 5 - Lột xác',
            views: 76807
        },
        {
            image: 'https://s199.imacdn.com/vg/2022/11/13/a8ed5dfa0809652f_1cd264c6fdaa01a4_3062316683126888118684.jpg',
            title: 'Tập 6 - Lời xin lỗi',
            views: 66646
        },
        {
            image: 'https://s199.imacdn.com/vg/2022/11/30/940cd3ef0aca2e19_995030cce874a04c_4088216697921853118684.jpg',
            title: 'Tập 7 - Nhiệt huyết sôi sục',
            views: 71528
        },
        {
            image: 'https://s199.imacdn.com/vg/2022/11/30/c0f5422111197ccc_3250af7d2b30ec62_3348716697921725118684.jpg',
            title: 'Tập 8 - Công thức thành công',
            views: 75593
        },
        {
            image: 'https://s199.imacdn.com/vg/2022/12/05/a92c4834daaf858f_dae19de4d4f3bdbf_2110216702182381118684.jpg',
            title: 'Tập 9 - Thức tỉnh',
            views: 72283
        },
        {
            image: 'https://s199.imacdn.com/vg/2022/12/11/3515ed78a9183619_b28cee4199bba911_27344167073291243.jpg',
            title: 'Tập 10 - Cứ như thế...',
            views: 67656
        },
        {
            image: 'https://s199.imacdn.com/vg/2022/12/19/575c8aa789df33f7_5b56418473779185_25471167138556343.jpg',
            title: 'Tập 11 - Mảnh ghép cuối cùng',
            views: 53043
        },
        {
            image: 'https://s199.imacdn.com/vg/2022/10/19/2c4230571a2039b9_bf71d200b518a2f4_6027216661555007118684.jpg',
            title: 'Tập 12',
            views: 12996
        }
    ]

    const movieList = itemList.map((item, index) => ({
        id: index,
        Component: <MovieListItem {...item} />
    }))
    return (
        <div className="container mx-auto">
            <div className="grid grid-cols-12 gap-2">
                <div className="col-span-9">
                    <VideoPlayer />
                </div>
                <div className="col-span-3">
                    <List options={movieList} />
                </div>
            </div>
            <div className="text-white">
                <div className="text-2xl">anime name</div>
                <div className="flex gap-2">
                    <div className="py-1 px-2 bg-green-500 rounded text-sm">
                        <i className="fa fa-heart"></i> Thích{' '}
                        <div className="inline-block">1234</div>
                    </div>
                    <div className="py-1 px-2 bg-red-500 rounded text-sm">
                        <i className="fa fa-bell"></i> Theo dõi{' '}
                        <div className="inline-block">1234</div>
                    </div>
                </div>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
            </div>
        </div>
    )
}
